import {useErrors} from '@management-ui/core';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {useRouteMatch} from 'react-router';
import {useHistory} from 'react-router-dom';
import {ServiceContext} from '../../../../components/Services';
import routes from '../../../../routes';
import Wrapper from './Wrapper';
import Detail from '../../../../components/TaskManager/Detail';

const Task = ({archive = false}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const match = useRouteMatch();

  const {errors, toggleError} = useErrors(
    useMemo(() => ({task: 'Sorry the task could not be accessed'}), [])
  );

  const idRef = useRef('');
  const [loading, setLoading] = useState(false);
  const [task, setTask] = useState(null);

  const loadTask = useCallback((id) => {
    if (idRef.current !== `${id}`) {
      idRef.current = `${id}`;
      setLoading(true);
      services.task.getTask(id, archive).then(retrieved => {
        setTask(retrieved);
        setLoading(false);
      }).catch(() => {
        toggleError('task', true);
        setLoading(false);
        setTimeout(() => {
          history.push(archive ? reverse(routes.archive.index, {tab: 'tasks'}) : routes.tasks.index);
        }, 3000);
      });
    }
  }, [archive, services, history, toggleError]);

  useEffect(() => {
    if (match.params?.id) {
      loadTask(match.params?.id);
    }
  }, [history, match, task, loadTask]);

  const [title, setTitle] = useState('Loading');
  const [crumbs, setCrumbs] = useState([...(archive ? Wrapper.archiveCrumbs : Wrapper.standardCrumbs)]);

  useEffect(() => {
    let header = 'Loading';
    let trail = [];
    if (task) {
      header = task.title;
      trail = [
        ...(task.archived ? Wrapper.archiveCrumbs : Wrapper.standardCrumbs),
        {title: header, link: ''}
      ];
    }
    setTitle(header);
    setCrumbs(trail);
  }, [task]);

  const handleDeleted = useCallback(() => {
    history.push(routes.tasks.index);
  }, [history]);

  const handleRestored = useCallback(() => {
    history.push(reverse(routes.tasks.detail, {id: task.id}));
  }, [task, history]);

  const handleChangeTask = useCallback((newTask) => {
    history.push(reverse(routes.tasks.detail, {id: newTask.id}));
  }, [history]);

  return (
    <Wrapper title={title} task={task} loading={loading} crumbs={crumbs} errors={errors}>
      {task?.id ? (
        <Detail
          task={task}
          onTaskUpdated={setTask}
          onLoading={setLoading}
          onRestored={handleRestored}
          onDeleted={handleDeleted}
          onChangeTask={handleChangeTask}
        />
      ) : null}
    </Wrapper>
  );
};

export default Task;
